import styled from "styled-components";

import * as u from "../utils";

export const Container = styled.div`
  max-width: 1440px;
  margin: auto;
  padding: 60px 16px;

  @media ${u.device.tablet} {
    padding: 20px;
  }

  @media ${u.device.desktop} {
    padding: 40px;
  }
`;
